import ApiService from './_api.service'
import { BranchParameter as Model } from '@/models/branchparameter.model'
import Utils from '../utils'

const BRANCH_COMPONENT_URL = '/v1/simulations/branchcomponents/'

const BranchComponentService = {
    read: function (args) {
        const queryParams = Utils.getQueryParams(args)
        return ApiService.get(BRANCH_COMPONENT_URL + queryParams)
    },

    readLatest: function (args) {
        const queryParams = Utils.getQueryParams(args)
        return ApiService.get(BRANCH_COMPONENT_URL + 'latest' + queryParams)
    },

    update: function (entity) {
        let data = new FormData()
        Object.keys(Model.editableFields).forEach(field => {
            if (entity[field] != null) data.set(field, entity[field])
        })
        return ApiService.patch(BRANCH_COMPONENT_URL, data)
    },

    deleteByBranchIds: function (simulation, branch_ids) {
        let data = new FormData()

        data.set('simulation', simulation)
        data.set(
            'branch_ids',
            branch_ids.reduce((a, b) => a + ',' + b)
        )

        return ApiService.delete(BRANCH_COMPONENT_URL, {
            data
        })
    }
}

export default BranchComponentService
export { BranchComponentService }
